import React from "react";
import { RotatingLines } from 'react-loader-spinner'
import LocationOffIcon from '@mui/icons-material/LocationOff';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
// import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';


export default ({ GeoLocationData }) => {
   const getDirection = (degrees, isLongitude) =>
      degrees > 0 ? (isLongitude ? "E" : "N") : isLongitude ? "W" : "S";

   // // adapted from http://stackoverflow.com/a/5786281/2546338
   const formatDegrees = (degrees, isLongitude) =>
      `${0 | degrees}° ${0 | (((degrees < 0 ? (degrees = -degrees) : degrees) % 1) * 60)
      }' ${0 | (((degrees * 60) % 1) * 60)}" ${getDirection(
         degrees,
         isLongitude,
      )}`;

   const coordDegree = `${formatDegrees(GeoLocationData?.coords?.latitude, false)} ,${formatDegrees(GeoLocationData?.coords?.longitude, true)} `

   return (
      <>
         {!GeoLocationData?.isGeolocationAvailable ? (
            <h6 className="error-field">Browser doesn't support Geolocation <WrongLocationIcon color='error' /></h6>
         ) : !GeoLocationData?.isGeolocationEnabled ? (
            <>
               <h6 className="error-field">Geolocation disabled <LocationOffIcon color='error' /></h6>
               <h6>Your location can't be found/determined, Hence can't proceed.</h6>
               <h6>Please check location permission from phone privacy/setting & browser to proceed.</h6>
                  
            
            </>
         ) : GeoLocationData?.coords ? (
            <>
               {/* <h6>{coords.latitude}</h6>
               <h6> {formatDegrees(coords.latitude, false)}</h6>
               <h6>{coords.longitude}</h6>
               <h6> {formatDegrees(coords.longitude, true)}</h6> */}
               {/* <h6>Location ON <PersonPinCircleIcon style={{ marginTop: '-4px' }} color='info' /> </h6> */}
            </>
         ) : (
            <h6>Locating coordinates <RotatingLines width="16" strokeColor="black" /> </h6>
         )
         }
      </>
   );
};


